export default {
  bairro: {
    value: null,
    required: true,
    state: null
  },
  cep: {
    value: null,
    maxlength: '9',
    required: true,
    state: null
  },
  complemento: {
    value: null,
    required: false,
    state: null
  },
  endereco: {
    value: null,
    required: true,
    state: null
  },
  municipio: {
    value: null,
    required: true,
    state: null
  },
  numero: {
    value: null,
    required: true,
    state: null
  },
  uf: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/addresses/modal/addressmodal-form.js